// // import React from "react";
// // import { Carousel, Typography, Button, Row, Col, Card } from "antd";
// // import { LeftOutlined, RightOutlined } from "@ant-design/icons";
// // import img1 from "../assest/2.png"
// // import img2 from "../assest/3.png"
// // import img3 from "../assest/4.png"
// // import img4 from "../assest/5.png"
// // import img6 from "../assest/6.png"

// // const { Title, Text } = Typography;

// // const clients = [
// //   { name: "Akhbar", img: img1 },
// //   { name: "Prime Research", img: img2 },
// //   { name: "VKSC Infraprojects Limited", img: img3 },
// //   { name: "Metro Interiors India", img: img4 },
// //   { name: "Metro Interiors India", img: img6 },
// // ];

// // const ClienteleSection = () => {
// //   const carouselRef = React.useRef(null);

// //   return (
// //     <div style={{ backgroundColor: "#0B4653", padding: "40px", color: "white" }}>
// //       <Row gutter={32} align="middle" style={{ display: "flex" }}>
// //         {/* Left Section (25%) */}
// //         <Col xs={24} md={6}>
// //           <Text style={{ color: "#5BD2FF", fontSize: 18 }}>Satisfied Client</Text>
// //           <Title level={2} style={{ color: "white", margin: "10px 0" }}>Our Clientele</Title>
// //           <div>
// //             <Button
// //               shape="circle"
// //               icon={<LeftOutlined />}
// //               onClick={() => carouselRef.current.prev()}
// //               style={{ marginRight: 10 }}
// //             />
// //             <Button
// //               shape="circle"
// //               icon={<RightOutlined />}
// //               onClick={() => carouselRef.current.next()}
// //             />
// //           </div>
// //         </Col>

// //         {/* Right Section (75%) */}
// //         <Col xs={24} md={18}>
// //           <Carousel ref={carouselRef} dots={false} autoplay slidesToShow={3}>
// //             {clients.map((client, index) => (
// //               <div key={index}>
// //                 <Card
// //                   style={{
// //                     height: 100,
// //                     margin: "0 10px",
// //                     display: "flex",
// //                     alignItems: "center",
// //                     justifyContent: "center",
// //                     borderRadius: 10,
// //                     background: "#fff",
// //                   }}
// //                 >
// //                   <img
// //                     src={client.img}
// //                     alt={client.name}
// //                     style={{ maxHeight: 60, objectFit: "contain" }}
// //                   />
// //                   {/* <div style={{ marginLeft: 10 }}>{client.name}</div> */}
// //                 </Card>
// //               </div>
// //             ))}
// //           </Carousel>
// //         </Col>
// //       </Row>
// //     </div>
// //   );
// // };

// // export default ClienteleSection;

// import React from "react";
// import { Row, Col, Typography, Card } from "antd";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";

// import logo1 from "../assest/2.png";
// import logo2 from "../assest/3.png";
// import logo3 from "../assest/4.png";
// import logo4 from "../assest/5.png";
// import logo5 from "../assest/6.png";

// const { Title, Text } = Typography;

// const stats = [
//   { count: "2,000+", label: "Trainings" },
//   { count: "50,000+", label: "Trained" },
//   { count: "25", label: "Clients" },
//   { count: "950+", label: "Training Consultant" },
// ];

// const logos = [logo1, logo2, logo3, logo4, logo5];

// const responsive = {
//   desktop: {
//     breakpoint: { max: 3000, min: 1024 },
//     items: 4,
//   },
//   tablet: {
//     breakpoint: { max: 1024, min: 768 },
//     items: 3,
//   },
//   mobile: {
//     breakpoint: { max: 768, min: 0 },
//     items: 1,
//   },
// };

// const ClientStatsSection = () => {
//   return (
//     <div>
//       {/* Blue Header Section */}
//       <div
//         style={{
//           background: "#318CE7",
//           color: "#fff",
//           padding: "60px 20px",
//           textAlign: "center",
//         }}
//       >
//         <Title level={2} style={{ color: "#fff" }}>
//           Our Clients
//         </Title>
//         <Text style={{ fontSize: 16, color: "#fff" }}>
//           Littera is used by Govt organisations, NGOs and Corporates for
//           outcome-based learning.
//         </Text>

//         <Row justify="center" gutter={[40, 20]} style={{ marginTop: 40 }}>
//           {stats.map((stat, index) => (
//             <Col key={index} xs={12} sm={12} md={6}>
//               <Title level={2} style={{ color: "#fff" }}>
//                 {stat.count}
//               </Title>
//               <Text style={{ color: "#fff", fontSize: "1.3rem" }}>
//                 {stat.label}
//               </Text>
//             </Col>
//           ))}
//         </Row>
//       </div>

//       {/* Logo Carousel Section */}
//       <div
//         style={{
//           background: "#fff",
//           padding: "40px 20px",
//           marginTop: -40,
//           borderRadius: "20px",
//           boxShadow: "0 0 20px rgba(0,0,0,0.1)",
//           maxWidth: 1200,
//           marginLeft: "auto",
//           marginRight: "auto",
//         }}
//       >
//         <Carousel
//           responsive={responsive}
//           infinite
//           autoPlay
//           autoPlaySpeed={3000}
//           arrows
//         >
//           {logos.map((logo, index) => (
//             <div key={index} style={{ padding: 10 }}>
//               <Card
//                 bordered={false}
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   height: 100,
//                 }}
//               >
//                 <img
//                   src={logo}
//                   alt={`logo-${index}`}
//                   style={{ maxHeight: 60, objectFit: "contain" }}
//                 />
//               </Card>
//             </div>
//           ))}
//         </Carousel>
//       </div>
//     </div>
//   );
// };

// export default ClientStatsSection;

import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@mui/material";
import axios from "axios";
import { message } from "antd";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 400,
  bgcolor: "background.paper",
  p: 4,
  borderRadius: 2,
  boxShadow: 24,
};

export default function ComplaintModal({ open, handleClose }) {
  const [step, setStep] = useState(1);
  const [roomNo, setRoomNo] = useState("");
  const [name, setName] = useState("");
  const [mobileNo, setMobileNo] = useState("");

  const [type, setType] = useState("");
  const [complaint, setComplaint] = useState("");
  const [complaintTypes, setComplaintTypes] = useState([]);
  const [feedback, setFeedback] = useState([]);
  const [remark, setRemark] = useState("");

  const [bookingDetails, setBookingDetails] = useState(null);

  const feedbackOptions = [
    "Cleanliness",
    "Food Quality",
    "Room Service",
    "Staff Behavior",
  ];

  const handleNext = async () => {
    if (roomNo && name && mobileNo) {
      try {
        const res = await axios.get(
          `https://hotelapi.shriyanshnath.com/api/Get_Booking_Customer_Detail`,
          {
            params: {
              name,
              mobileno: mobileNo,
              roomno: roomNo,
              hotelid: "9C7B6342-F97B-4F90-A699-1E8CE9F723A9",
            },
          }
        );
        setBookingDetails(res.data); // Save booking + customer details
        setStep(2);
      } catch (err) {
        console.error("Booking details fetch failed", err);
        alert("Failed to fetch customer details. Please check your info.");
      }
    } else {
      alert("Please fill all fields");
    }
  };

  const handleTypeSelection = async (selectedType) => {
    setType(selectedType);
    if (selectedType === "complain") {
      try {
        const res = await axios.get(
          `https://hotelapi.shriyanshnath.com/api/Get_Complaint_Type?hotelid=9C7B6342-F97B-4F90-A699-1E8CE9F723A9`
        );
        setComplaintTypes(res.data);
      } catch (err) {
        console.error("Failed to load complaint types", err);
        alert("Could not fetch complaint types.");
      }
    }
  };

  const handleSubmit = async () => {
    if (type === "complain") {
      const payload = {
        id: "",
        customerid: bookingDetails?.customerid || "",
        bookingid: bookingDetails?.bookingid || "",
        complaint_date: new Date().toISOString(),
        complaint_type: complaint,
        complaint: remark,
        complaint_no: "",
      };

      try {
        await axios.post(
          "https://hotelapi.shriyanshnath.com/api/Save_Complaint",
          payload
        );
        setStep(3); // Show thank you message step
      } catch (err) {
        console.error("Submit failed", err);
        message.error("❌ Submission failed. Please try again.");
      }
    }
  };

  const resetForm = () => {
    setStep(1);
    setRoomNo("");
    setName("");
    setMobileNo("");
    setType("");
    setComplaint("");
    setFeedback([]);
    setRemark("");
    setBookingDetails(null);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") handleClose();
        }}
      >
        <Box sx={style}>
          {step === 1 && (
            <>
              <Typography variant="h6">Enter Your Room Number</Typography>
              <TextField
                fullWidth
                margin="normal"
                label="Room Number"
                value={roomNo}
                onChange={(e) => setRoomNo(e.target.value)}
              />
              <Typography variant="h6">Enter Your Name</Typography>
              <TextField
                fullWidth
                margin="normal"
                label="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <Typography variant="h6">Enter Your Mobile Number</Typography>
              <TextField
                fullWidth
                margin="normal"
                label="Mobile Number"
                value={mobileNo}
                onChange={(e) => setMobileNo(e.target.value)}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button variant="contained" onClick={handleNext}>
                  Next
                </Button>
              </Box>
            </>
          )}

          {step === 2 && !type && (
            <>
              <Typography variant="h6" align="center">
                Choose Action
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  justifyContent: "center",
                  mt: 2,
                }}
              >
                {/* <Button
                variant="outlined"
                onClick={() => handleTypeSelection("feedback")}
              >
                Feedback
              </Button> */}
                <Button
                  variant="outlined"
                  onClick={() => handleTypeSelection("complain")}
                  sx={{ py: 2, px: 4, fontSize: "1rem" }} // Bigger button
                >
                  Complaint
                </Button>
              </Box>
            </>
          )}

          {type === "complain" && (
            <>
              <Typography variant="h6" gutterBottom>
                Complaint Form
              </Typography>
              <FormControl fullWidth margin="normal">
                <InputLabel>Complaint Type</InputLabel>
                <Select
                  value={complaint}
                  onChange={(e) => setComplaint(e.target.value)}
                  label="Complaint Type"
                >
                  {complaintTypes.map((item) => (
                    <MenuItem key={item.id} value={item.typename}>
                      {item.typename}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                fullWidth
                multiline
                rows={3}
                label="Enter Remark"
                margin="normal"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
              <Button variant="contained" fullWidth onClick={handleSubmit}>
                Submit
              </Button>
            </>
          )}

          {type === "feedback" && (
            <>
              <Typography variant="h6" gutterBottom>
                Feedback Form
              </Typography>
              <FormControl fullWidth margin="normal">
                <InputLabel>Select Feedback</InputLabel>
                <Select
                  multiple
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  input={<OutlinedInput label="Select Feedback" />}
                  renderValue={(selected) => selected.join(", ")}
                >
                  {feedbackOptions.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={feedback.indexOf(name) > -1} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Enter Remark"
                margin="normal"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
              <Button variant="contained" onClick={handleClose}>
                Submit Feedback
              </Button>
            </>
          )}
        </Box>
      </Modal>

      <Modal
        open={step === 3}
        onClose={() => {
          resetForm();
          handleClose();
        }}
      >
        <Box sx={{ ...style, textAlign: "center" }}>
          <Typography variant="h5" gutterBottom>
            🎉 Thank you for your suggestion!
          </Typography>
          <Typography variant="body1" gutterBottom>
            We appreciate your feedback 😊
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => {
              resetForm();
              handleClose();
            }}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </>
  );
}
